import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';

const NotFound = function() {
    return (
        <div className='NotFound'>
            <div className='Error404'>
                <h1 className='fw-bolder'><i class="fa-solid fa-triangle-exclamation"></i> ERROR: 404</h1>
                <p className='text-light'>
                    Упс... Кажется, данной страницы не существует. <br />
                    Возможно, эта страница находится в разработке.
                </p>
                <Link to="/">
                    <Button variant="primary" size="sm"><i class="fa-solid fa-arrow-left"></i> Вернуться назад</Button>
                </Link>
            </div>

            <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
        </div>
    )
}

export default NotFound;